import { Button } from "components/atoms";
import { Form } from "components/organisms";
import {
  userFormInitialValues,
  userTabs,
} from "components/organisms/forms/user/UserForm";
import { FormikHelpers } from "formik";
import { useMutateOptions } from "hooks";
import { useTranslation } from "react-i18next";
import { PiUserPlus, PiX } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useRegisterUser } from "services/userManagement";
import { IRegisterUserForm } from "services/userManagement/types";
import { BUTTON_VARIANT } from "types/components/button/button.interface";

const CreateUser = () => {
  const { mutateAsync, isPending } = useRegisterUser();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const mutateOptions = useMutateOptions<IRegisterUserForm>();

  const i18nextPrefix = "user";

  const handlePostUser = async (
    values: IRegisterUserForm,
    helpers: FormikHelpers<IRegisterUserForm>
  ) => {
    await mutateAsync(values, {
      ...mutateOptions(helpers),
      onSuccess: ({ id }) => {
        navigate(`/settings/users/${id}/permissions`);
      },
    });
  };
  return (
    <Form.User
      i18nextPrefix={i18nextPrefix}
      initialValues={userFormInitialValues}
      onSubmit={handlePostUser}
      disableTabs={[userTabs.permissions]}
      tittle={t("user.title.create")}
      customBackItem={
        <Button
          type="button"
          onlyIcon
          onClick={() => navigate("/settings/users")}
        >
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type="submit" variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t("button.create")} />
          <Button.Icon icon={<PiUserPlus />} />
        </Button>
      }
    />
  );
};

export default CreateUser;
